export enum ErrorMessages {
  SAME_PHONE = 'O número que você está solicitando alteração já se encontra cadastrado.',
  ALREADY_PHONE = 'Já existe uma solicitação em aberto para alteração desse dado.',
}
